import { formatDate } from "./HelpfulFunctions";

const splitAssocPath = "\\w[^\\.]+";

export function filterDate(filterInfo, data) {
    
    var dateParsed;
    var value = data[filterInfo.id];

    if (typeof value === "string") {
         dateParsed = new Date(value);    
    }
    else {
        dateParsed = value;
    }

    if (filterInfo.value == dateParsed.getDate())
        return true;
    else if (filterInfo.value == dateParsed.getMonth() + 1)
        return true;
    else if (filterInfo.value == dateParsed.getFullYear())
        return true;
    else {
        var dateFormatted = formatDate(dateParsed);
        if (filterInfo.value == dateFormatted)
            return true;
        else if (filterInfo.value.length >=3 && filterInfo.value == dateFormatted.substr(0, filterInfo.value.length))
            return true;
    } 

    return false;
}

export function filterMatchSubstring(filterInfo, data, assocPath) {
    if (filterInfo.value) {

        var value = null;

        if (typeof assocPath === "string")
            value = getAssociatedValue(data, assocPath);
        else
            value = data[filterInfo.id];

        var filterValue = filterInfo.value.toLowerCase();

        if (typeof value === "string")
            value = value.toLowerCase();
        
        if (filterValue === value.substr(0, filterValue.length))
            return true;
    }

    return false;
}

export function filterContains(filterInfo, data, assocPath) {
    if (filterInfo.value) {

        var value = null;

        if (typeof assocPath === "string")
            value = getAssociatedValue(data, assocPath);
        else
            value = data[filterInfo.id];

        var filterValue = filterInfo.value.toLowerCase().trim();

        if (typeof value === "string")
            value = value.toLowerCase();
        
        if (value.includes(filterValue))
            return true;
    }

    return false;
}

export function filterEnum(enumMetadata, filterInfo, data) {

    var value = data[filterInfo.id];
    var filterValue = filterInfo.value.toLowerCase();

    var item = enumMetadata.Items[value];
    if (item.Caption && item.Caption.substr(0, filterValue.length).toLowerCase() === filterValue)
        return true;

    return false;
}

function getAssociatedValue(filterData, _assocPath) {
    
    // Handle association paths in accessors eg. Item.Unit.Description
    var accPath = [..._assocPath.matchAll(splitAssocPath)];
    var instance = filterData["_original"];
    var value = instance[accPath[0]];

    for (var i = 1; i < accPath.length; i++) {
        instance = value;
        value = instance[accPath[i]];
    }

    return value;
}